import React from 'react';
import {Ellipse} from '@ey/canvascoreservices';

const Ellipses = {
	Single: ({children, tooltip, ...props}) => {
		return <Ellipse content={children} tooltip={!tooltip ? children : tooltip} noOfLines={1} {...props} />;
	},
	Double: ({children, tooltip, ...props}) => {
		return <Ellipse content={children} tooltip={!tooltip ? children : tooltip} noOfLines={2} {...props} />;
	}
};

Ellipses.Single.displayName = 'SingleLineEllipses';
Ellipses.Double.displayName = 'DoubleLineEllipses';

export default Ellipses;
